import React, { useEffect, useRef, useState } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import { CModal } from '@coreui/react';
import Select from 'react-select';
import Swal from 'sweetalert2';
import ReactPlayer from 'react-player';
import { generateAxiosInstanceSection } from '../../hooks/useAuthorizedRequestForSection';
import { generateAxiosInstanceInstitute } from '../../hooks/useAuthorizedRequestForInstitute';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../../components/ModalsCommonFunctions';
import { deleteItem, findPageNumber, searchArray, SortIcon } from '../../components/Navigation';
import Pagination from '../../components/Pagination';

const SectionVideoContentUpload = () => {
    const authorizedAxiosSection = generateAxiosInstanceSection()
    const authorizedAxiosInstitute = generateAxiosInstanceInstitute()
    let instituteMasterId = localStorage.getItem("instituteMasterId")
    let sectionMasterId = localStorage.getItem("sectionMasterId")

    const initialFormState = {
        instituteMasterId: instituteMasterId,
        sectionMasterId: sectionMasterId,
        filePath: '',
        fileName: '',
        description: '',
        title: '',
        tagMasterId: '',
        instituteGradeMasterIds: ['']
    }
    const [play, setPlay] = useState(false)
    const [PdfBookData, setPdfBookData] = useState(initialFormState)
    const [videoList, setVideoList] = useState([])
    const [editId, setEditId] = useState(null)
    const [visible, setVisible] = useState(false)
    const [showPdfLink, setShowPdfLink] = useState("")
    const [tag, setTag] = useState([])
    const [classList, setClassList] = useState([])
    const [played, setPlayed] = useState(0);
    const playerRef = useRef(null);
    const [volume, setVolume] = useState(0.5);
    const [playbackRate, setPlaybackRate] = useState(1);
    const [isFullScreen, setFullScreen] = useState(false);

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);

    const [tagSort, setTagSort] = useState(null);
    const [videoNameSort, setVideoNameSort] = useState(null);
    const [videoTitleSort, setVideoTitleSort] = useState(null);
    const [videoDescriptionSort, setVideoDescriptionSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["sectionVideoMasterDetails.instituteGradeMasterDetails.gradeName", "fileName", "tagMasterDetails.tagName", "title", "description"];


    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        const apiUrl2 = `/get-institute-grade?instituteMasterId=${instituteMasterId}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl2)
            .then(response => {
                setClassList(response.data.result.map((sub) => {
                    return {
                        value: sub.id,
                        label: sub.gradeName
                    }
                }))
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });

        const apiUrl = `/get-section-tag-master?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrl)
            .then(response => {
                setTag(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }, []);

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            getVideoList();
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        setVideoList(await searchArray("B", getApiUrl(), searchKeys, searchValue.trim()))
    }

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(videoList, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId])

    useEffect(() => {
        setTotalPages(Math.ceil(videoList.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > videoList.length) {
            endIndex = videoList.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(videoList.slice(startIndex, endIndex));
    }, [videoList, currPage, itemsPerPage]);

    useEffect(() => {
        getVideoList();
    }, [PdfBookData.instituteGradeMasterIds, PdfBookData.tagMasterId]);

    const getApiUrl = () => {
        let apiUrl = `/get-section-video-list?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}&`;
        if (PdfBookData.instituteGradeMasterIds.length != 0) {
            apiUrl += `instituteGradeMasterIds=${PdfBookData.instituteGradeMasterIds}&`;
        }
        if (PdfBookData.tagMasterId !== '') {
            apiUrl += `tagMasterId=${PdfBookData.tagMasterId}&`;
        }

        apiUrl = apiUrl.replace(/&$/, '');
        return apiUrl;
    }

    const getVideoList = async () => {
        try {
            const response = await authorizedAxiosSection.get(getApiUrl());
            setVideoList(response.data.result);
        } catch (error) {
            setVideoList([]);
            console.error('Error fetching data:', error);
        }
    }

    const handleInputChange = (e) => {
        setPdfBookData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value
            }
        })
    }

    const initialErrorState = {

    }
    const [error, setError] = useState(initialErrorState)
    const validateForm = () => {
        return Object.values(error).every((error) => error === '') && Object.values(PdfBookData).every((value) => typeof (value) == "string" ? value !== '' : value.length !== 0)
    };

    useEffect(() => {
        if (!Object.values(error).every((error) => error === '')) {
            for (const [key, value] of Object.entries(PdfBookData)) {
                if (value === '' || value.length === 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }, [PdfBookData])

    const addLesson = async () => {
        const apiUrl = `/add-section-video`;
        if (validateForm()) {
            try {
                setLoading(true);
                const response = await authorizedAxiosSection.post(apiUrl, PdfBookData)
                await getVideoList();
                setPdfBookData((prevData) => {
                    return {
                        ...prevData,
                        filePath: '',
                        fileName: '',
                        title: '',
                        description: ''
                    }
                })

                setSaveId(response.data.result.id);
                setTagSort(null);
                setVideoNameSort(null);
                setVideoTitleSort(null);
                setVideoDescriptionSort(null);

                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        } else {
            for (const [key, value] of Object.entries(PdfBookData)) {
                if (value === '' || value.length === 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }

    const deleteLesson = async (id) => {
        let confirmed = window.confirm('Are you sure? you want to delete this record.');
        if (confirmed) {
            try {
                setLoading(true);
                const apiUrl = `/delete-section-video?id=${id}`;
                const response = await authorizedAxiosSection.delete(apiUrl)
                const page = deleteItem(currPage, itemsPerPage, videoList.length);
                await getVideoList();
                setCurrPage(page);

                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        }
    }

    const handleSeekChange = (e) => {
        const seekValue = parseFloat(e.target.value);
        setPlayed(seekValue);
        playerRef.current.seekTo(seekValue, 'fraction');
    };

    const handleProgress = (progress) => {
        setPlayed(progress.played);
    };

    const handleVolumeChange = (e) => {
        setVolume(parseFloat(e.target.value));
    };

    const handleSpeedChange = (e) => {
        setPlaybackRate(parseFloat(e.target.value));
    };

    const handleChangeBoard = (selectedOptions) => {
        const selectedIds = selectedOptions?.map((option) => option.value.toString());
        setPdfBookData((prevData) => {
            return {
                ...prevData,
                instituteGradeMasterIds: selectedIds,
            }
        })
    }


    useEffect(() => {
        if (tagSort == true || tagSort == false) {
            setVideoNameSort(null);
            setVideoTitleSort(null);
            setVideoDescriptionSort(null);
        }
    }, [tagSort])

    useEffect(() => {
        if (videoNameSort == true || videoNameSort == false) {
            setTagSort(null);
            setVideoTitleSort(null);
            setVideoDescriptionSort(null);
        }
    }, [videoNameSort])

    useEffect(() => {
        if (videoTitleSort == true || videoTitleSort == false) {
            setTagSort(null);
            setVideoNameSort(null);
            setVideoDescriptionSort(null);
        }
    }, [videoTitleSort])

    useEffect(() => {
        if (videoDescriptionSort == true || videoDescriptionSort == false) {
            setTagSort(null);
            setVideoNameSort(null);
            setVideoTitleSort(null);
        }
    }, [videoDescriptionSort])

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/section-dashboard')}>
                                <span>Dashboard</span>
                            </li>

                            <li className="breadcrumb-item active"><span>Section Upload Video Content</span></li>
                        </ol>
                    </nav>
                </div>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-cloud-arrow-up"></i> Section Upload Video Content </b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Grade :</label>
                                                    <Select
                                                        value={classList.filter(option =>
                                                            PdfBookData.instituteGradeMasterIds && PdfBookData.instituteGradeMasterIds.includes(option.value.toString())
                                                        )}
                                                        isMulti
                                                        name="instituteGradeMasterIds"
                                                        options={classList}
                                                        className="basic-multi-select"
                                                        classNamePrefix="Select Board"
                                                        onChange={handleChangeBoard}
                                                    />
                                                    {error.instituteGradeMasterIds && <p style={{ color: 'red' }}>{error.instituteGradeMasterIds}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Tag :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='tagMasterId' onChange={handleInputChange} value={PdfBookData.tagMasterId}>
                                                        <option selected value={''} disabled>Select Tag</option>
                                                        {
                                                            tag?.map((syllabus) => {
                                                                return <option value={syllabus.id}>{syllabus.tagName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.tagMasterId && <p style={{ color: 'red' }}>{error.tagMasterId}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>File Name:</label>
                                                    <input required type="text" className="form-control" name="fileName" value={PdfBookData.fileName} onChange={handleInputChange} />
                                                    {error.fileName && <p style={{ color: 'red' }}>{error.fileName}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Video Url:</label>
                                                    <input required type="text" className="form-control" name="filePath" value={PdfBookData.filePath} onChange={handleInputChange} />
                                                    {error.filePath && <p style={{ color: 'red' }}>{error.filePath}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Title:</label>
                                                    <input required type="text" className="form-control" name="title" value={PdfBookData.title} onChange={handleInputChange} />
                                                    {error.title && <p style={{ color: 'red' }}>{error.title}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Description:</label>
                                                    <input required type="text" className="form-control" name="description" value={PdfBookData.description} onChange={handleInputChange} />
                                                    {error.description && <p style={{ color: 'red' }}>{error.description}</p>}
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>
                                                    <div className="col-auto">
                                                        {!editId && <button className="btn btn-primary" type="button" style={{ marginRight: '20px' }} onClick={addLesson}>Save</button>
                                                        }
                                                        <button className="btn btn-outline-danger delete_icon" type="reset" style={{ marginRight: '20px' }} onClick={() => { setVideoList([]); setEditId(''); setPdfBookData(initialFormState) }}>Reset</button>
                                                    </div>
                                                </div>

                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table custom_table-width">
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col" className='sl_no'>Sr. No.</th>
                                                                        <th scope="col">Class </th>
                                                                        <th scope="col">
                                                                            Video Name
                                                                            <SortIcon sortState={videoNameSort} setSortState={setVideoNameSort} setData={setVideoList} setCurrPage={setCurrPage} sortingPath={"fileName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Tag Name
                                                                            <SortIcon sortState={tagSort} setSortState={setTagSort} setData={setVideoList} setCurrPage={setCurrPage} sortingPath={"tagMasterDetails.tagName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Video Title
                                                                            <SortIcon sortState={videoTitleSort} setSortState={setVideoTitleSort} setData={setVideoList} setCurrPage={setCurrPage} sortingPath={"title"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Video Description
                                                                            <SortIcon sortState={videoDescriptionSort} setSortState={setVideoDescriptionSort} setData={setVideoList} setCurrPage={setCurrPage} sortingPath={"description"} />
                                                                        </th>
                                                                        <th scope="col">Video</th>
                                                                        <th scope="col">Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        displayedData.length > 0 ?
                                                                            displayedData.map((lesson, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <th scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                        <td>{lesson.sectionVideoMasterDetails?.map((i) => `${i?.instituteGradeMasterDetails?.gradeName}`)}</td>
                                                                                        <td>{lesson.fileName}</td>
                                                                                        <td>{lesson?.tagMasterDetails?.tagName}</td>
                                                                                        <td>{lesson.title}</td>
                                                                                        <td>{lesson.description}</td>
                                                                                        <td>
                                                                                            <button className="btn btn-primary view_icon" type="button" onClick={() => {
                                                                                                setShowPdfLink(lesson?.url)
                                                                                                setVisible(true)
                                                                                            }}><i class="fa fa-eye" ></i></button>
                                                                                        </td>
                                                                                        <td>
                                                                                            <button className="btn btn-outline-danger delete_icon" type="button" onClick={() => deleteLesson(lesson.id)}> <i class="fa-light fa-trash-can"></i></button>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Videos Available</th>
                                                                            </tr>)
                                                                    }
                                                                </tbody>
                                                            </table>
                                                            <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={videoList.length} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />

            <CModal
                backdrop="static"
                visible={visible}
                onClose={() => setVisible(false)}
                aria-labelledby="LiveDemoExampleLabel"
                className={isFullScreen ? "full_scr_view" : ""}
            >
                <button className="close-button video-close" onClick={() => setVisible(false)}><i class="fa fa-window-close fa-2xl" aria-hidden="true"></i></button>
                <div className="test test-player">
                    <ReactPlayer
                        ref={playerRef}
                        url={showPdfLink}
                        playing={play}
                        volume={volume}
                        onProgress={handleProgress}
                        playbackRate={playbackRate}
                    >
                    </ReactPlayer>
                    <div className="overlay-layer">
                        <div className="trigger" onClick={() => setPlay(!play)} >Play</div>
                    </div>
                </div>
                <div className="video_content_bottom">
                    <div className="video_progress">
                        <input
                            type="range"
                            min={0}
                            max={1}
                            step="any"
                            value={played}
                            onChange={handleSeekChange}
                            className="input_slider"
                        />
                    </div>


                    <div className='play_pause_sound'>
                        <div className='sound'>
                            {!play ? <button onClick={() => setPlay(true)} className="play_pause_btn"> <i class="fa fa-play"></i></button> :
                                <button onClick={() => setPlay(false)} className="play_pause_btn"><i class="fa fa-pause"></i></button>}

                            {volume >= 0.5 && <button className='play_pause_btn'>
                                <i class="fa fa-volume-high"></i>
                            </button>}
                            {volume < 0.5 && volume > 0 && <button className='play_pause_btn'>
                                <i class="fa fa-volume-low"></i>
                            </button>}
                            {volume == 0 && <button className='play_pause_btn'>
                                <i class="fa fa-volume-xmark"></i>
                            </button>}

                            <div className='sound_bar'>
                                <input
                                    type="range"
                                    value={volume}
                                    onChange={handleVolumeChange}
                                    min="0"
                                    max="1"
                                    step="0.01"
                                    className="input_slider"
                                />
                            </div>
                        </div>
                        <div className='playbeack_speed'>
                            <span>Playback speed</span>
                            <select onClick={handleSpeedChange}>
                                <option value={0.25}>0.25</option>
                                <option value={0.5}>0.5</option>
                                <option value={0.75}>0.75</option>
                                <option selected value={1}>Normal</option>
                                <option value={1.25}>1.25</option>
                                <option value={1.5}>1.5</option>
                                <option value={1.75}>1.75</option>
                            </select>
                        </div>
                        {/* <div className='fullscreen_mode'>
                                                            <button className='full_scr_btn' onClick={() => setFullScreen(!isFullScreen)}> {isFullScreen ? <i class="fa fa-expand"></i> : <i class="fa fa-compress"></i>}</button>
                                                        </div> */}

                        <div className='fullscreen_mode'>
                            <button className='full_scr_btn' onClick={() => setFullScreen(!isFullScreen)}>{isFullScreen ? <i className="fa fa-compress"></i> : <i className="fa fa-expand"></i>}</button>
                        </div>
                    </div>
                </div>
            </CModal>
        </>
    )
};

export default SectionVideoContentUpload;